/* istanbul ignore file */

/** Returns true if current window is inside an iframe */
export function isInsideIframe() {
    return window.parent !== window;
}
